var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCompanyNoInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.6667 39H25.3333M36.1667 39V5.22222C36.1667 4.10242 35.7101 3.02848 34.8975 2.23666C34.0848 1.44484 32.9826 1 31.8333 1H10.1667C9.0174 1 7.91519 1.44484 7.10254 2.23666C6.28988 3.02848 5.83333 4.10242 5.83333 5.22222V39H36.1667ZM36.1667 39H40.5H36.1667ZM36.1667 39H25.3333H36.1667ZM5.83333 39H1.5H5.83333ZM5.83333 39H16.6667H5.83333ZM14.5 9.44444H16.6667H14.5ZM14.5 17.8889H16.6667H14.5ZM25.3333 9.44444H27.5H25.3333ZM25.3333 17.8889H27.5H25.3333ZM16.6667 39V28.4444C16.6667 27.8845 16.8949 27.3476 17.3013 26.9517C17.7076 26.5558 18.2587 26.3333 18.8333 26.3333H23.1667C23.7413 26.3333 24.2924 26.5558 24.6987 26.9517C25.1051 27.3476 25.3333 27.8845 25.3333 28.4444V39H16.6667Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 39C36.4036 39 42 33.4036 42 26.5C42 19.5964 36.4036 14 29.5 14C22.5964 14 17 19.5964 17 26.5C17 33.4036 22.5964 39 29.5 39Z",
    fill: "#FF5959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9752 30.736L32 17H27L27.9938 30.736H30.9752ZM31.8137 37V32.8427H27.1863V37H31.8137Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCompanyNoInfo);
export default __webpack_public_path__ + "static/media/ico_company_no_info.68ef3df10ee9cc71f2dbfd2c81f6b85b.svg";
export { ForwardRef as ReactComponent };